import { render, staticRenderFns } from "./procesosRevision.vue?vue&type=template&id=50d1a803&scoped=true"
import script from "./procesosRevision.vue?vue&type=script&lang=js"
export * from "./procesosRevision.vue?vue&type=script&lang=js"
import style0 from "./procesosRevision.vue?vue&type=style&index=0&id=50d1a803&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d1a803",
  null
  
)

export default component.exports